import {
  ApplicabilityItemEnum,
  MacroCategoryEnum,
  PriceBasisEnum,
  PriceTypeEnum,
} from '@msc-b2c/interfaces/enums';
import { IPriceListResponseCruises } from '../../../../../../interfaces/src/lib/interfaces/index';

// 1. Import this mock response where the getPriceLists is called with first arg -> BookingAPIEndpoints.PRICETYPES
// 2. Comment out the getPriceLists execution and set the data state with the following response.
// 3. setloading to false

// example: at the PackageCardWrapper:
// setCardData(responseCruisesMock.priceTypes);
// setLoading(false);
// For the price list set the Package card Wrapper set  cardData.length > 0  at the return because in order to see the ONE package card returned.
export const responseCruisesMock: IPriceListResponseCruises = {
  priceTypes: [
    {
      priceType: 'PROMOMKT',
      lowestPricedCategory: {
        priceCode: 'DIC00969GB5014PR',
        priceDescription: 'Save and Sail Cruise Only',
        cabinType: 'YTC',
        categoryCode: 'YC2',
        macroCategory: MacroCategoryEnum.YACHT,
        allowedOccupancies: '4',
        passengerType: '',
        portChargesAmount: '0.00',
        totalAllInclusiveCabinPrice: {
          beforeDiscount: '10427.00',
          afterDiscount: '10427.00',
        },
        totalCabinPrice: {
          beforeDiscount: '10427.00',
          afterDiscount: '10427.00',
        },
        maximumOccupancy: {
          real: 4,
          guaranteed: 0,
        },
        pricesPerPassenger: [
          {
            passengerId: '-9999',
            allInclusive: {
              beforeDiscount: '4119.00',
              afterDiscount: '4119.00',
            },
            charges: [
              {
                chargeType: 'CAB',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '4119.00',
                  afterDiscount: '4119.00',
                },
                gross: {
                  beforeDiscount: '4119.00',
                  afterDiscount: '4119.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          {
            passengerId: '-9998',
            allInclusive: {
              beforeDiscount: '4119.00',
              afterDiscount: '4119.00',
            },
            charges: [
              {
                chargeType: 'CAB',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '4119.00',
                  afterDiscount: '4119.00',
                },
                gross: {
                  beforeDiscount: '4119.00',
                  afterDiscount: '4119.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          {
            passengerId: '-9997',
            allInclusive: {
              beforeDiscount: '2189.00',
              afterDiscount: '2189.00',
            },
            charges: [
              {
                chargeType: 'CHD',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '2189.00',
                  afterDiscount: '2189.00',
                },
                gross: {
                  beforeDiscount: '2189.00',
                  afterDiscount: '2189.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
        ],
        items: [
          {
            code: 'DUOPR',
            date: '2025-03-14',
            description: 'Duo - Two Exclusive Dining Experiences',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '141.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 22,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573155843',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'FORFAI',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'SPABAEXP',
            date: '2025-03-14',
            description: 'Balinese Massage 50 Minute',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '80.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 22,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573155855',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'SPA',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'SPABBEXP',
            date: '2025-03-14',
            description: 'Bamboo Massage - 50 min',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '91.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 22,
            itemPriority: 1,
            maxItems: 4,
            minItems: 0,
            occurrence: '0',
            packageCode: '573155865',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'SPA',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'SCUI814',
            date: '2025-03-14',
            description: 'SERVICE CHARGE - GRATUITIES are included in the cruise fare',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 41,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156100',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'SERVICEC',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: 'EXPYCB',
            date: '2025-03-14',
            description: 'MSC Yacht Club Benefits',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 43,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156117',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'MISC',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          {
            code: '603',
            date: '2025-03-14',
            applicability: ApplicabilityItemEnum.MANDATORY,
            endDateOffset: '2025-03-14',
            grossPrice: '0.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 46,
            itemPriority: 1,
            maxItems: 1,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156150',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            typeCode: 'MSC',
            parentPackageCode: '',
            serviceType: '',
            description: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
            costCurrency: '',
          },
        ],
      },
      allowedOccupancies: '',
    },
    {
      priceType: 'STANDARD',
      lowestPricedCategory: {
        priceCode: 'STD00123GB5014PR',
        priceDescription: 'Standard Cruise Package',
        cabinType: 'YTC',
        categoryCode: 'YC3',
        macroCategory: MacroCategoryEnum.BALCONY,
        allowedOccupancies: '2',
        passengerType: '',
        portChargesAmount: '50.00',
        totalAllInclusiveCabinPrice: {
          beforeDiscount: '8500.00',
          afterDiscount: '8050.00',
        },
        totalCabinPrice: {
          beforeDiscount: '8500.00',
          afterDiscount: '8050.00',
        },
        maximumOccupancy: {
          real: 2,
          guaranteed: 0,
        },
        pricesPerPassenger: [
          {
            passengerId: '-10000',
            allInclusive: {
              beforeDiscount: '4250.00',
              afterDiscount: '4025.00',
            },
            charges: [
              {
                chargeType: 'CAB',
                totalDiscountAmount: '250.00',
                commission: {
                  beforeDiscount: {
                    standard: '100.00',
                    bonus: '50.00',
                    total: '150.00',
                  },
                  afterDiscount: {
                    standard: '80.00',
                    bonus: '30.00',
                    total: '110.00',
                  },
                },
                net: {
                  beforeDiscount: '4250.00',
                  afterDiscount: '4025.00',
                },
                gross: {
                  beforeDiscount: '4250.00',
                  afterDiscount: '4025.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          // Additional passengers...
        ],
        items: [
          {
            code: 'SPA101',
            date: '2025-03-14',
            description: 'Basic Spa Package',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-03-14',
            grossPrice: '120.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 24,
            itemPriority: 2,
            maxItems: 2,
            minItems: 0,
            occurrence: '0',
            packageCode: '573155900',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.NIGHT,
            quantity: 1,
            serviceType: 'SPA',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          // Additional items...
        ],
      },
      allowedOccupancies: '',
    },
    {
      priceType: 'PRDRINK',
      lowestPricedCategory: {
        priceCode: 'DRV01234GB5014PR',
        priceDescription: 'Premium Drink Package',
        cabinType: 'YTC',
        categoryCode: 'PD1',
        macroCategory: MacroCategoryEnum.BALCONY,
        allowedOccupancies: '2',
        passengerType: '',
        portChargesAmount: '25.00',
        totalAllInclusiveCabinPrice: {
          beforeDiscount: '9000.00',
          afterDiscount: '9000.00',
        },
        totalCabinPrice: {
          beforeDiscount: '9000.00',
          afterDiscount: '9000.00',
        },
        maximumOccupancy: {
          real: 2,
          guaranteed: 0,
        },
        pricesPerPassenger: [
          {
            passengerId: '-10001',
            allInclusive: {
              beforeDiscount: '4500.00',
              afterDiscount: '4500.00',
            },
            charges: [
              {
                chargeType: 'DRK',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '2500.00',
                  afterDiscount: '2500.00',
                },
                gross: {
                  beforeDiscount: '2500.00',
                  afterDiscount: '2500.00',
                },
              },
              {
                chargeType: 'SRN',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
              {
                chargeType: 'PCH',
                totalDiscountAmount: '0.00',
                commission: {
                  beforeDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                  afterDiscount: {
                    standard: '0.00',
                    bonus: '0.00',
                    total: '0.00',
                  },
                },
                net: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
                gross: {
                  beforeDiscount: '0.00',
                  afterDiscount: '0.00',
                },
              },
            ],
          },
          // Additional passengers...
        ],
        items: [
          {
            code: 'PRD101',
            date: '2025-04-01',
            description: 'Premium Beverage Package',
            applicability: ApplicabilityItemEnum.OPTIONAL,
            endDateOffset: '2025-04-01',
            grossPrice: '200.00',
            isAvailable: true,
            isPerCabinPrice: false,
            itemNumber: 30,
            itemPriority: 3,
            maxItems: 2,
            minItems: 0,
            occurrence: '0',
            packageCode: '573156200',
            priceBasis: PriceBasisEnum.PER_PERSON,
            priceType: PriceTypeEnum.STAY,
            quantity: 1,
            serviceType: 'BEVERAGE',
            typeCode: 'OBS',
            costCurrency: 'EUR',
            parentPackageCode: '',
            defaultAirportCode: '',
            originAirportCode: '',
            destinationAirportCode: '',
          },
          // Additional items...
        ],
      },
      allowedOccupancies: '',
    },
    // More priceTypes...
  ],
};
